function debounce(func, wait, immediate) {
  var timeout;
  return {
    func: function() {
      var context = this,
          args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    },
    cancel: function() {
      clearTimeout(timeout);
    }
  };
}

window.wbPicture = (function() {
  // [0]: hostname + pathname
  // [1]: size (_100x or _x100 or _100x100)
  // [2]: crop (_crop_top, _crop_bottom, etc.)
  // [3]: scale (undefined or @2x or @3x)
  // [4]: format (.png or .jpg)
  // [5]: version (?v=1234)
  var replaceImgRegex = /(_\d+x\d+|_\d+x|_x\d+)?(_crop_\w+)?(@\dx)?(\.jpg|\.png|\.gif|\.mp4)(\?v=\d+)?/;

  function replaceImgUrlAdvanced(oldSrc, newSrc, options) {
    var oldParts = oldSrc.split(replaceImgRegex);
    var newParts = newSrc.split(replaceImgRegex);
    oldParts[0] = newParts[0];
    if (options) {
      if (options.master) {
      oldParts[1] = '';
      oldParts[2] = newParts[2];
      oldParts[3] = '';
      }
      if (options.size) {
        oldParts[1] = '_' + options.size;
      }
      if (options.crop) {
        oldParts[2] = '_crop_' + options.crop;
      }
    }
    oldParts[4] = newParts[4];
    oldParts[5] = newParts[5];
    return oldParts.join('');
  }

  function replaceImgSrcsetUrlsAdvanced(oldSrcset, newSrc, options) {
    return oldSrcset.split(/, ?/).map(function(part) {
      return replaceImgUrlAdvanced(part, newSrc, options);
    }).join(', ');
  }

  function replaceImgSrc(img, src, options) {
    if ((img.dataset && img.dataset.wasProcessed) || (typeof img.src !== 'undefined' && img.src)) {
      img.src = replaceImgUrlAdvanced(img.src, src, options);
    } else {
      img.dataset.src = replaceImgUrlAdvanced(img.dataset.src, src, options);
    }
  }

  function replaceSourcesSrc(sources, src, options) {
    sources.forEach(function(source) {
      if (typeof source.srcset !== 'undefined' && source.srcset) {
        source.srcset = replaceImgSrcsetUrlsAdvanced(source.srcset, src, options)
      } else {
        source.dataset.srcset = replaceImgSrcsetUrlsAdvanced(source.dataset.srcset, src, options);
      }
    });
  }

  function replaceDataZoomSrc(img, src, options) {
    if (img.dataset && typeof img.dataset.zoomSrc !== 'undefined' && img.dataset.zoomSrc) {
      img.dataset.zoomSrc = replaceImgUrlAdvanced(img.dataset.zoomSrc, src);
    }
  }

  function replaceDataMagnifySrc(img, src, options) {
    if (img.dataset && typeof img.dataset.magnifySrc !== 'undefined' && img.dataset.magnifySrc) {
      img.dataset.magnifySrc = replaceImgUrlAdvanced(img.dataset.magnifySrc, src, options);
    }
  }

  function replacePictureSrcAdvanced(element, src, options) {
    var elements = [];
    if (typeof jQuery === 'function' && element instanceof jQuery) {
      elements = Array.prototype.slice.call(element.toArray());
    } else if (!Array.isArray(element)) {
      elements = [element];
    }

    elements.filter(function (element) { return Boolean(element); }).forEach(function(element) {
      if (element !== null && element.tagName === 'IMG') {
        element = element.closest('picture');
      }
      if (element !== null && element.tagName !== 'PICTURE') {
        element = element.querySelector('picture') || element.querySelector('img');
      }
      if (element !== null && ['PICTURE', 'IMG'].indexOf(element.tagName) !== -1) {
        var img = element.tagName === 'IMG' ? element : element.getElementsByTagName('img')[0];
        var sources = Array.prototype.slice.call(element.getElementsByTagName('source'));
        replaceImgSrc(img, src, options);
        replaceSourcesSrc(sources, src, options);
        replaceDataZoomSrc(img, src, options);
        replaceDataMagnifySrc(img, src, options);
      }
    });
  }

  return {
    replaceSrc: replacePictureSrcAdvanced
  };

})();



document.addEventListener('DOMContentLoaded', function() {
  //Additional FB& IG Tracking
  function addToCartAd(){
    if (Cookies.get('adfb') !== undefined){
      $('#add-to-cart-form').prepend('<select id="adTracking" class="hidden" name="properties[ad]"><option value="FB"></option></select>');
    }else if(Cookies.get('adig') !== undefined){
      $('#add-to-cart-form').prepend('<select id="adTracking" class="hidden" name="properties[ad]"><option value="IG"></option></select>');
    }
  }
  addToCartAd();

  window.wbProductZoom = (function() {
    var id = 'product_zoom',
        idSmile = 'smile-ui-container',
        idButtonClose = 'product_zoom_close',
        idMobile = 'product_zoom_mobile',
        idMobileIconWrapper = 'product_zoom_icon_wrapper',
        idMobilePinch = 'product_zoom_mobile_pinch',
        idDesktopSwiper = 'product_zoom_desktop_swiper',
        classShow = 'wb-product-zoom--show',
        classMobileImg = 'wb-product-zoom-mobile__img',
        classMobileImgMaster = 'wb-product-zoom-mobile__img--master',
        classMasterShow = 'wb-product-zoom-mobile__img--master-show',
        classDesktopZoomContainer = 'wb-product-zoom-desktop__swiper-zoom-container',
        elZoom,
        elButton,
        elMobile,
        pinchZoom,
        elIcon,
        elPinch,
        elPictureWrapper,
        elPictureCanvas,
        elPictureImg,
        elPictureImgMaster,
        elVideo,
        elDesktopSwiper,
        rectDesktopWrapper;

    function measureScrollbarWidth() {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      var scrollbarWith = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWith;
    }

    function setScrollbarAdjustments() {
      var rect = document.body.getBoundingClientRect();
      var isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      var scrollbarWidth = measureScrollbarWidth();

      if (isBodyOverflowing) {
        // Adjust body padding
        var actualPadding = document.body.style.paddingRight;
        var actualOverflow = document.body.style.overflow;
        var calculatedPadding = window.getComputedStyle(document.body).paddingRight;

        document.body.dataset.paddingRight = actualPadding;
        document.body.dataset.overflow = actualOverflow;
        document.body.style.paddingRight = (parseFloat(calculatedPadding) + scrollbarWidth) + 'px';
        document.body.style.overflow = 'hidden';
      }
    }

    function resetScrollbarAdjustments() {
      var padding = document.body.dataset.paddingRight;
      var overflow = document.body.dataset.overflow;
      if (typeof padding === 'undefined') {
        document.body.style.paddingRight = '';
      } else {
        document.body.dataset.paddingRight = '';
        document.body.dataset.overflow = '';
        document.body.style.paddingRight = padding;
        document.body.style.overflow = overflow;
      }
    }

    function isDesktop() {
      return window.getComputedStyle(elMobile).display === 'none';
    }

    function resetZoom() {
      if (!elPinch.style.height) {
        pinchZoom.setContainerY(elZoom.clientHeight);
      }

      var scaleX = pinchZoom.getContainerX() / pinchZoom.el.clientWidth;
      var scaleY = pinchZoom.getContainerY() / pinchZoom.el.clientHeight;
      var scale = Math.max(scaleY, pinchZoom.el.clientHeight / pinchZoom.getContainerY());
      var scaleOffset = Math.max(scaleY, scaleX);
      pinchZoom.initialOffset.x = (pinchZoom.getContainerX() - pinchZoom.el.clientWidth) / 2;
      pinchZoom.initialOffset.y = -(pinchZoom.getContainerY() - pinchZoom.el.clientHeight) / 2;
      pinchZoom.offset.x = (pinchZoom.getContainerX() * scaleOffset - pinchZoom.el.clientWidth) / 2;
      pinchZoom.offset.y = -(pinchZoom.getContainerY() - pinchZoom.el.clientHeight * scaleOffset) / 2;
      pinchZoom.zoomFactor = scale;
      pinchZoom.lastScale = scale;
      pinchZoom.options.minZoom = scale;
      pinchZoom.options.zoomOutFactor = scale;
      pinchZoom.update();
    }

    function resetSwiper() {
      //
    }

    function reset() {
      if (isDesktop()) {
        resetSwiper();
      } else {
        resetZoom();
      }
    }

    function hideSmile() {
      var smile = document.getElementById(idSmile);
      if (smile) {
        smile.style.display = 'none';
      }
    }

    function showSmile() {
      var smile = document.getElementById(idSmile);
      if (smile) {
        smile.style.display = '';
      }
    }

    function updateHTMLPosition() {
      hideSmile();
      setTimeout(function() {
        if (!isDesktop()) {
          document.body.appendChild(elZoom);
        }
        hideSmile();
      }, 500);
    }

    function getRectDesktopWrapper() {
      rectDesktopWrapper = document.querySelector('#' + idDesktopSwiper + ' .swiper-wrapper').getBoundingClientRect(window);
    }

    var onResize = debounce(getRectDesktopWrapper, 200);

    function hide() {
      elZoom.classList.remove(classShow);
      showSmile();
      if (isDesktop()) {
        resetScrollbarAdjustments();
        resetSwiper();
        window.removeEventListener('resize', onResize.func, false);
      } else {
        if (elPictureImg) {
          elPictureWrapper.removeChild(elPictureImg);
          elPictureImg = null;
        }
        if (elVideo) {
          elPictureWrapper.removeChild(elVideo);
          elVideo = null;
        }
        elPictureImgMaster.classList.remove(classMasterShow);
        elPictureImgMaster.src = '';
        resetZoom();
      }
    }

    function initMobile() {
      if (elZoom && pinchZoom) {
        return;
      }

      function setupPinchZoom() {
        if (typeof pinchZoom !== 'undefined') {
          return;
        }
        pinchZoom = new PinchZoom(elPinch, {
          tapZoomFactor: 3,
          zoomOutFactor: 3,
          animationDuration: 500,
          minZoom: 1,
          maxZoom: 3,
          draggableUnzoomed: true,
          setOffsetsOnce: true,
          lockDragAxis: false
        });
      }

      elPictureWrapper = document.createElement('div');
      elPictureWrapper.className = 'wb-picture-wrapper wb-video-wrapper';
      elPictureCanvas = document.createElement('canvas');
      elPictureCanvas.className = 'wb-picture__canvas';
      elPictureImgMaster = document.createElement('img');
      elPictureImgMaster.className = 'wb-picture__img ' + classMobileImg + ' ' + classMobileImgMaster;

      elPictureWrapper.appendChild(elPictureCanvas);
      elPinch.appendChild(elPictureWrapper);

      setupPinchZoom();

      // NOTE: Add <img> after initializing PinchZoom to prevent event listeners being added to them.
      elPictureWrapper.appendChild(elPictureImgMaster);

      resetZoom();

      elPictureImgMaster.addEventListener('load', function() {
        elPictureImgMaster.classList.add(classMasterShow);
      });
    }

    function initDesktop(clickEvent) {
      if (elZoom && elDesktopSwiper) {
        return;
      }

      var lastOffsetX;
      var lastOffsetY;

      function setInitialOffsets(clickEvent) {
        if (rectDesktopWrapper.left <= clickEvent.x && clickEvent.x <= rectDesktopWrapper.right) {
          lastOffsetX = clickEvent.x - rectDesktopWrapper.left;
          if (rectDesktopWrapper.top <= clickEvent.y && clickEvent.y <= rectDesktopWrapper.bottom) {
            lastOffsetY = clickEvent.y - rectDesktopWrapper.top;
          }
        }
      }

      function setupSwiper() {
        if (typeof elDesktopSwiper !== 'undefined') {
          return;
        }

        function getCoordinates(swiper, event) {
          if (event) {
            lastOffsetX = event.x - rectDesktopWrapper.left;
            lastOffsetY = event.y - rectDesktopWrapper.top;
          }
          var x = Math.min(Math.max((lastOffsetX / swiper.$(swiper.wrapperEl).outerWidth()) * 100, 0), 100);
          var y = Math.min(Math.max((lastOffsetY / swiper.$(swiper.wrapperEl).outerHeight()) * 100, 0), 100);
          return [x, y];
        }

        function onMouseLeave(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(225).transform('translate3d(0,0,0) scale(1)').css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
          if (event) {
            lastOffsetX = undefined;
            lastOffsetY = undefined;
          }
        }
        function onMouseMove(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          if (typeof lastOffsetX === 'undefined' || typeof lastOffsetY === 'undefined') { return; }
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(0).css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
        }
        function onMouseEnter(event) {
          var swiper = this;
          var xy = getCoordinates(swiper, event);
          swiper.$zoomEl.each(function(elIndex, elZoom) {
            swiper.$(elZoom).transition(0).transform('translate3d(0,0,0) scale(2)').css('transformOrigin', xy[0] + '% ' + xy[1] + '%');
          });
        }

        elDesktopSwiper = new Swiper('#' + idDesktopSwiper, {
          on: {
            init: function() {
              var swiper = this;
              swiper.$wrapperEl.each(function(elIndex, elWrapper) {
                elWrapper = swiper.$(elWrapper);
                elWrapper.on('mouseenter', onMouseEnter.bind(swiper), false);
                elWrapper.on('mousemove', onMouseMove.bind(swiper), false);
                elWrapper.on('mouseleave', onMouseLeave.bind(swiper), false);
              });
              swiper.$zoomEl = swiper.$wrapperEl.find('.' + classDesktopZoomContainer);
            },
          },
          direction: 'vertical',
          slidesPerView: 1,
          spaceBetween: 10,
          initialSlide: 0,
          roundLengths: true,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            invert: true
          },
          speed: 500,
          loop: false,
          autoplay: false,
          lazyLoad: {
            enabled: true,
            loadPrevNext: true
          },
          thumbs: {
            swiper: {
              el: '#product_zoom_desktop_swiper_thumbs',
              direction: 'vertical',
              slidesPerView: 6,
              spaceBetween: 5,
              roundLengths: false,
              mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
                invert: true
              },
              speed: 500,
              loop: false,
              autoplay: false,
              lazyLoad: true
            }
          }
        });
      }

      getRectDesktopWrapper();
      setupSwiper();

      if (clickEvent) {
        setInitialOffsets(clickEvent);
      }

      resetSwiper();
    }

    function showMobile(srcEl) {
      if (!srcEl || !(Boolean(srcEl.dataset.zoomSrc) || srcEl.tagName === 'VIDEO')) {
        return;
      }
      //return on safari till update bug is fixed
      // if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
      //   return;
      // }

      initMobile();


      if (srcEl.tagName === 'VIDEO') {
        elVideo = srcEl.cloneNode(true);

        elPictureCanvas.width = srcEl.dataset.zoomWidth || 1440;
        elPictureCanvas.height = srcEl.dataset.zoomHeight || 1800;

        elPictureWrapper.insertBefore(elVideo, elPictureImgMaster);
        resetZoom();
        elZoom.classList.add(classShow);
        elIcon.style.opacity = 0;
        elPictureImgMaster.src = '';
      } else {
        elPictureImg = (srcEl.tagName === 'PICTURE' ? srcEl : srcEl.closest('picture')).cloneNode(true);
        elPictureImg.querySelector('img').className = 'wb-picture__img ' + classMobileImg;

        var srcMaster = srcEl.dataset.zoomSrc;

        if (!elPictureImg || !srcMaster) {
          return;
        }

        elPictureCanvas.width = srcEl.dataset.zoomWidth || 1440;
        elPictureCanvas.height = srcEl.dataset.zoomHeight || 1800;

        elPictureWrapper.insertBefore(elPictureImg, elPictureImgMaster);
        resetZoom();
        elZoom.classList.add(classShow);
        elIcon.style.opacity = 0;
        elPictureImgMaster.src = srcMaster;
      }
    }

    function showDesktop(srcEl, clickEvent) {
      if (!srcEl || typeof srcEl.dataset.index === 'undefined') {
        return;
      }

      setScrollbarAdjustments();

      elZoom.classList.add(classShow);

      initDesktop(clickEvent);

      resetSwiper();

      var index = parseInt(srcEl.dataset.index) || 0;

      elDesktopSwiper.slideTo(index, 0);
    }

    function show(srcEl, clickEvent) {
      if (!srcEl) {
        return;
      }

      if (!elZoom) {
        elZoom = document.getElementById(id);
        elButton = document.getElementById(idButtonClose);
        elMobile = document.getElementById(idMobile);
        elIcon = document.getElementById(idMobileIconWrapper);
        elPinch = document.getElementById(idMobilePinch);
        elButton.addEventListener('click', hide, { passive: true });

        document.body.appendChild(elZoom);

        document.addEventListener('WBContentLoaded', updateHTMLPosition, false);
        document.addEventListener('sweettooth-ready', updateHTMLPosition, false);

        if (isDesktop()) {
          window.addEventListener('resize', onResize.func, false);
        }
      }

      if (isDesktop()) {
        showDesktop(srcEl, clickEvent);
      } else {
        showMobile(srcEl);
      }

      hideSmile();
    }

    return {
      reset: reset,
      show: show
    };
  })();


  Array.prototype.slice.call(document.querySelectorAll('.wb-fashion__product-image-container .wb-picture__img, .wb-fashion__product-image-container .wb-video-wrapper video')).forEach(function(image) {
    image.addEventListener('click', function (event) {
      window.wbProductZoom.show(event.target, event);
    }, { passive: true });
  });

  function setupProductImageSlider(id) {
    var product_image_slider = document.getElementById(id);
    if (!product_image_slider || product_image_slider.className.indexOf('swiper-container-initialized') !== -1) {
      return;
    }

    var product_image_slider_thumbs = document.getElementById(id+'_thumbs');
    var thumbs = {};
    if (product_image_slider_thumbs) {
      var slidesperview = 4;
      // if(product_image_slider_thumbs.classList.contains('product_image_slider_mobile_thumbs-fashion')){
      //   var slidesperview = 6;
      // }
      thumbs.swiper = {
        el: product_image_slider_thumbs,
        navigation: {
          nextEl: '#' + product_image_slider_thumbs.id + ' + .wb-slider__nav2 .wb-slider__nav2-next',
          prevEl: '#' + product_image_slider_thumbs.id + ' + .wb-slider__nav2 .wb-slider__nav2-prev',
          disabledClass: 'wb-slider__nav2--disabled',
          hiddenClass: 'wb-slider__nav2--disabled'
        },
        slidesPerView: slidesperview,
        spaceBetween: 5,
        roundLengths: false,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          invert: true
        },
        lazyLoad: true
      };
    }
    /// https://stackoverflow.com/questions/21377842/jquery-slider-move-nearest-slide-to-edge/21495762 fixes sticky slide after freemode slide
    return new Swiper(product_image_slider, {
      on: {
        click: function(event) {
          window.wbProductZoom.show(event.target);
        },
        touchEnd: function(event){
          //document.querySelector('html').style.overflowY = 'auto';
        },
        touchStart: function(event){
          //document.querySelector('html').style.overflowY = 'hidden';
        },
      },
      navigation: {
        nextEl: '#' + product_image_slider.id + ' .wb-product-image-slider__nav-next',
        prevEl: '#' + product_image_slider.id + ' .wb-product-image-slider__nav-prev',
        disabledClass: 'wb-product-image-slider__nav--disabled',
        hiddenClass: 'wb-product-image-slider__nav--disabled'
      },
      scrollbar: {
        el: '.wb-product-image-slider__scrollbar',
        // dragClass: 'wb-product-image-slider__scrollbar-drag',
        enabled: true,
        draggable: false,
        dragSize: 60,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      queueEndCallbacks: true,
      roundLengths: true,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        invert: true
      },
      lazyLoad: {
        enabled: true,
        loadPrevNext: true
      },
      thumbs: thumbs,
    });
  }

  var swiper = setupProductImageSlider('product_image_slider_mobile');
  var swiper2 = setupProductImageSlider('product_image_slider_mobile2');

  window.wbProductSlider = {
    slideTo: function (index) {
      swiper.slideToLoop(index);
      swiper2?.slideToLoop(index);
    },
    changeFlavor: function (index) {
      if (typeof index === 'undefined') {
        return
      }
      var mobileSliderThumbsEl = document.getElementById('product_image_slider_mobile_thumbs');
      if (!mobileSliderThumbsEl) {
        return;
      }

      var lifestylePictureWrappersDesktop;
      var lifestylePictureWrappers;
      var lifestyleThumbsPictureWrappers;

      function queryLifestylePictureWrappers(elements) {
        if (!elements) { return [] }
        return Array.prototype.slice.call(elements).map(function (el) { return el.hasAttribute('data-index') ? el : el.querySelector('.wb-picture-wrapper[data-index]'); }).filter(function (el) { return parseInt(el.dataset.index) > 0; });
      }

      function ensureWrappersInititalized() {
        if (!lifestylePictureWrappersDesktop) {
          lifestylePictureWrappersDesktop = queryLifestylePictureWrappers(document.querySelector('.wb-single-product_product-image-previews-container').children);
        }
        if (!lifestylePictureWrappers) {
          lifestylePictureWrappers = queryLifestylePictureWrappers(document.querySelectorAll('#product_image_slider_mobile .swiper-slide, #product_image_slider_mobile2 .swiper-slide'));
        }
        if (!lifestyleThumbsPictureWrappers) {
          lifestyleThumbsPictureWrappers = queryLifestylePictureWrappers(document.querySelectorAll('#product_image_slider_mobile_thumbs .swiper-slide, #product_image_slider_mobile_thumbs2 .swiper-slide'));
        }
      }

      if (mobileSliderThumbsEl.dataset.flavorImages) {
        try {
          var flavorImages = JSON.parse(atob(mobileSliderThumbsEl.dataset.flavorImages)).splice(index * 4, 4);
          if (flavorImages && flavorImages.length >= 4) {
            ensureWrappersInititalized();
            flavorImages.forEach(function (image, index) {
              window.wbPicture.replaceSrc(lifestylePictureWrappersDesktop[index], image);
              window.wbPicture.replaceSrc(lifestylePictureWrappers[index], image);
              window.wbPicture.replaceSrc(lifestyleThumbsPictureWrappers[index], image);
            });
          }
        } catch (e) {
          console.log(e)
        }
      }

      if (mobileSliderThumbsEl.dataset.flavorLifestyleImages) {
        try {
          var flavorLifestyleImages = JSON.parse(atob(mobileSliderThumbsEl.dataset.flavorLifestyleImages));
          if (flavorLifestyleImages.length > index) {
            var lifestyleImage = flavorLifestyleImages[index].image;
            if (lifestyleImage) {
              ensureWrappersInititalized();
              window.wbPicture.replaceSrc(lifestylePictureWrappersDesktop[0], lifestyleImage);
              window.wbPicture.replaceSrc(lifestylePictureWrappers[0], lifestyleImage);
              window.wbPicture.replaceSrc(lifestyleThumbsPictureWrappers[0], lifestyleImage);
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
  };

  // fix safari scroll ux
  $('#product_image_slider_mobile,#product_image_slider_mobile2').scroll(function(event) {
    $(this).scrollLeft(0)
    $(this).css('overflow','hidden');
    swiper.slideTo(swiper.realIndex);
    swiper2?.slideTo(swiper.realIndex);
    setTimeout(function(){
      $(this).css('overflow','scroll hidden');
    },1);
  });

}, { passive: true });

document.addEventListener('DOMContentLoaded', function() {

  var productPage = document.querySelector('.wb-single-product');
  var isFashionSet = productPage && productPage.classList.contains('wb-fashion-set');


  var color_switch_sliderAll = document.querySelectorAll('.product-variants .fashion-color-switch');

  var color_switch_title = document.getElementById('fashion-color-switch-item-title');




if(isFashionSet){
color_switch_sliderAll.forEach(function(color_switch_slider){

  if (!color_switch_slider || color_switch_slider.className.indexOf('swiper-container-initialized') !== -1 || document.getElementById('fashion-color-switch')) {
    return;
  }
  /*
 var swiper = new Swiper(color_switch_slider, {
    on: {
      init: function() {
        */
        var classNoActive = 'wb-fashion-color-switch--noactive';
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.item a'));
        var current_title = color_items[0].getAttribute('title');
        var currentSetColor = current_title;

        function resetColorSwitchTitle() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }

        var resetColorSwitchTitleDebounced = debounce(resetColorSwitchTitle, 225);


          color_items.forEach(function(el){

            el.addEventListener('click', function() {
              currentSetColor = el.getAttribute('title');
              color_switch_title.innerText = currentSetColor;
              console.log('click',el.getAttribute('title'));
              $('[data-color="'+decodeURIComponent(el.getAttribute('title')).replace(/\+/g, ' ')+'"]').trigger('click');
            });

            el.addEventListener('mouseenter', function() {
              color_switch_title.innerText = el.getAttribute('title');
            });

          });
          color_switch_slider.addEventListener('mouseleave', function() {
            color_switch_title.innerText = currentSetColor;
          });
/*
      }
    },
    navigation: {
      nextEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-next',
      prevEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-prev',
      disabledClass: 'wb-fashion-color-switch__nav--disabled',
      hiddenClass: 'wb-fashion-color-switch__nav--disabled'
    },
    slidesPerView: 'auto',
    spaceBetween: 5,
    roundLengths: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    speed: 500,
    freeMode: true,
    freeModeMomentumVelocityRatio: 0.8,
    freeModeMomentumBounce: false, // Remove this when upgraded to >= v6.3.4
    lazyLoad: true
  });
*/
});

  return;
}

  var color_switch_slider = document.getElementById('fashion-color-switch');
 if (!color_switch_slider || color_switch_slider.className.indexOf('swiper-container-initialized') !== -1 || document.getElementById('fashion-color-switch')) {
    return;
  }
 /*
  var swiper = new Swiper(color_switch_slider, {
    on: {
      init: function() {
        var swiper = this;
        if (swiper.slides.length <= 1) {
        */
        var items = color_switch_slider.querySelectorAll('.item');
        if (items.length <= 1) {
          var wrapperEl = color_switch_slider.closest('.product-variants');
          if (wrapperEl && wrapperEl.childElementCount === 1) {
            if(window.location.pathname.indexOf('eco-bottle-white') === -1 && window.location.pathname.indexOf('hot-cold-bottle') === -1){
            wrapperEl.style.display = 'none';
            }
          }
        }

        var classNoActive = 'wb-fashion-color-switch--noactive';
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.item a, a.item'));
        var current_title = color_items[0].getAttribute('title');

        function resetColorSwitchTitle() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }

        var resetColorSwitchTitleDebounced = debounce(resetColorSwitchTitle, 225);

        color_items[0].addEventListener('mouseenter', function() {
          color_switch_slider.classList.remove(classNoActive);
          color_switch_title.innerText = current_title;
        }, { passive: true });
        color_items.slice(1).forEach(function(el) {
          el.addEventListener('mouseenter', function() {
            resetColorSwitchTitleDebounced.cancel();
            color_switch_slider.classList.add(classNoActive);
            color_switch_title.innerText = el.getAttribute('title');
          }, { passive: true });
          el.addEventListener('mouseleave', resetColorSwitchTitleDebounced.func);
        });
        color_switch_slider.addEventListener('mouseleave', resetColorSwitchTitle, { passive: true });
        /*
      }
    },
    navigation: {
      nextEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-next',
      prevEl: '#' + color_switch_slider.id + ' .wb-fashion-color-switch__nav-prev',
      disabledClass: 'wb-fashion-color-switch__nav--disabled',
      hiddenClass: 'wb-fashion-color-switch__nav--disabled'
    },
    slidesPerView: 'auto',
    spaceBetween: 5,
    roundLengths: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    speed: 500,
    freeMode: true,
    freeModeMomentumVelocityRatio: 0.8,
    freeModeMomentumBounce: false, // Remove this when upgraded to >= v6.3.4
    lazyLoad: true
  });
*/


}, { passive: true });




document.addEventListener('DOMContentLoaded', function () {

  window.changeVariantImages = function changeVariantImages(variant) {
    var flavorId = variant.getAttribute('data-flavor');
    var imgSrc = variant.getAttribute('data-img-src');

    Array.prototype.slice.call(document.querySelectorAll('.fitness-info-flex [data-flavors]')).forEach(function (element) {
      if (flavorId && imgSrc && element && (element.getAttribute('data-flavors') || '').split(/,/).indexOf(flavorId) !== -1) {
         window.wbPicture.replaceSrc(element, imgSrc, { crop: 'bottom' });
      }
    });

    if (window.wbProductSlider.changeFlavor && variant.dataset.index) {
      window.wbProductSlider.changeFlavor(variant.dataset.index);
    }

  }

  window.changeVariantSize = function changeVariantSize(variant) {
    var newSize = variant.getAttribute('data-serving-size');
    var sizeLabel = document.getElementsByClassName('product-servings__label')[0];

    if (sizeLabel && sizeLabel.textContent != newSize) {
      sizeLabel.textContent = newSize;
    }
  }


  // function which takes the current clicked variant as input, gets the price and updates it on the website
  window.changeVariantPrice = function changeVariantPrice(selectedOptions) {
    var options = document.querySelectorAll('option');
    var currentPrice = document.querySelector('.product-price__price');
    var currentPriceCompare = document.querySelector('.product-price__price-compare');
    var currentPriceOff = document.querySelector('.product-price__savings');
    var newPrice;
    var newPriceCompare;
    var newPriceOff;



    for(var i=0; i < options.length; i++){
      if(options[i].dataset.price == undefined){
        return;
      }
      if(selectedOptions.dataset.sku == options[i].dataset.sku){
        newPrice = options[i].dataset.price;
        newPriceCompare = options[i].dataset.priceCompare;
        newPriceOff = options[i].dataset.priceOff;
      }
    }


    if(currentPrice.innerText != newPrice && newPrice !== undefined){
      currentPrice.innerText = newPrice;
      currentPriceCompare.innerText = newPriceCompare;
      currentPriceOff.innerText = newPriceOff;
    }

  }

  window.changeVariantContents = function changeVariantContents(variant) {
    var sku = variant.getAttribute('data-sku');
    if (!sku) {
      return;
    }
    sku = sku.replace(/^OF/, '');
    function updateContentSku(parent) {
      if (!parent) {
        parent = document;
      }
      Array.prototype.slice.call(parent.querySelectorAll('[data-content-sku]')).forEach(function (element) {
        if ((element.getAttribute('data-content-sku') || '').split(/,/).map(function (sku) { return sku.replace(/^OF/, ''); }).indexOf(sku) === -1) {
          element.style.display = 'none';
        } else {
          element.style.display = '';
        }
      });
    }
    var bundleProperties = (variant.getAttribute('value') || '').split(/,/);
    if (bundleProperties.length > 1 && bundleProperties[1]) {
      var elements = Array.prototype.slice.call(document.querySelectorAll('[data-content-handle]')).filter(function (element) {
        return (element.getAttribute('data-content-handle') || '').split(/,/).indexOf(bundleProperties[1]) !== -1;
      });
      elements.forEach(updateContentSku);
    } else {
      updateContentSku();
    }
  }

  window.handleVariantUrl = function handleVariantUrl(variant) {
    if (!variant || !variant.dataset.url) {
      return;
    }
    var newUrl = window.location.origin + variant.dataset.url;
    if (newUrl == window.location.href) {
      return;
    }
    window.location.href = newUrl;
  }

  function setupFlavorButtons() {
    Array.prototype.slice.call(document.querySelectorAll('.product-flavors-container')).forEach(function (element) {
      var title = element.querySelector('.product-flavors-title__variant');
      var list = element.querySelector('.product-flavors');
      var size = document.querySelectorAll('.variant-col-input .product-flavors-title__variant')[0];

      if (!title || !list) {
        return;
      }

      function handleFlavorChange(flavors, flavor, event) {
        if (flavor.classList.contains('disabled') || flavor.hasAttribute('disabled')) {
          return;
        }

        flavors.forEach(function (flavor) {
          flavor.classList.remove('active');
        });
        flavor.classList.add('active');
        list.classList.remove('red');
        title.innerText = flavor.innerText;
        if(flavor.getAttribute("data-serving-size") != '' && size != undefined){
          size.textContent = flavor.getAttribute("data-serving-size");
        }
        window.changeVariantImages(flavor);
        window.changeVariantContents(flavor);
        window.handleVariantUrl(flavor);
        window.changeVariantPrice(flavor);
      }

      var flavors = Array.prototype.slice.call(list.querySelectorAll('li'));
      flavors.forEach(function (flavor) {
        flavor.addEventListener('click', handleFlavorChange.bind(null, flavors, flavor));
        flavor.addEventListener('mouseenter', function () {
          title.innerText = flavor.innerText;
        });
        flavor.addEventListener('mouseleave', function () {
          flavors.forEach(function (flavor) {
            if (!flavor.classList.contains('active')) {
              return;
            }
            title.innerText = flavor.innerText;
          });
        });
      });
    });
  }

  function setupQuantityInput() {
    Array.prototype.slice.call(document.querySelectorAll('.wb-quantity-input')).forEach(function (element) {
      var input = element.querySelector('input');
      var decButton = element.querySelector('button[data-quantity-dec]');
      var incButton = element.querySelector('button[data-quantity-inc]');
      if (!input || !decButton || !incButton) {
        return;
      }
      var minValue = input.hasAttribute('min') ? Number(input.getAttribute('min')) : 1;
      var maxValue = input.hasAttribute('max') ? Number(input.getAttribute('max')) : Number.MAX_SAFE_INTEGER;
      decButton.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = Math.max(minValue, Number(input.value) - 1);
      });
      incButton.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = Math.min(maxValue, Number(input.value) + 1);
      });
    });
  }

  setupFlavorButtons();
  setupQuantityInput();

}, { passive: true });

jQuery(document).ready( function($) {
  function setupReadMore() {
    var showChar = 480;
    var ellipsestext = "";
    var moretext = "... Show more";
    var lesstext = "Show less";
    var counter = 1;
    var t = 200,linear;
    var lang = document.documentElement.lang.split(/-/)[0];
    switch (lang) {
      case "de":
        moretext = "... mehr";
        lesstext = "weniger";
        break;
      case "fr":
        moretext = "... Voir plus";
        lesstext = "Voir moins";
        break;
      case "ar":
        moretext = "... أظهر المزيد";
        lesstext = "أقل";
        break;
    }
    $('.more p').first().addClass('first-p');
    $('.more').each(function(index) {
      var content = $(this).html();
      var textLength = $(this).text();
      var moreElement = $(this);
      //console.log(index)


      var c = content.substr(0, showChar);

      var h = content.substr(showChar, content.length);


      var l = c.length + h.indexOf('.')+1;

      c = content.substr(0,l);

      h = content.substr(l, content.length);




      // console.log(c,h);


      //console.log(content.length,l,h.length)


      //console.log('c:'+ c);
      //console.log('h:'+ h);


      if(content.length > l && h.length > 50) {

        $(this).addClass('add-more-setup');

        //console.log('c:'+ c);
        //console.log('h:'+ h);

        //var html = '<span class="first-'+index+'">' +c + '</p></span><a href="javascript:;" class="morelink'+index+' first">'+ moretext + '</a><span class="moreellipses'+index+'">' + ellipsestext+ '</span><span class="morecontent'+index+'"><span><p>' + h + '</span><a href="javascript:;" class="lesslink'+index+' last">' + lesstext + '</a></span>';
        var html = '<span class="first-'+index+'">' +c + '</p></span><a href="javascript:;" class="morelink'+index+' first">'+ moretext + '</a><span class="moreellipses'+index+'">' + ellipsestext+ '</span><span class="morecontent morecontent'+index+'"><span><p>' + h + '</span><a href="javascript:;" class="lesslink'+index+' last">' + lesstext + '</a></span>';
        $(this).html(html);
      }




      if($('.morelink'+index).is(':visible')){
      }else {
        $('.first-'+index+' p:nth-child(2)').show();
        $('.morecontent'+index).hide();
        if($('.morelink'+index).is(':visible')){
        }else {
          $('.first-'+index+' p:nth-child(3)').show();
          $('.morecontent'+index).hide();

        }
      }
      $(".morelink"+index).click(function(){
        $('.more-'+index+' .last').show(t);
        $('.more-'+index+' .first').hide(t);
        $(this).addClass("less");
        $('.morelink'+index).html(lesstext);
        $('.more'+index+' .first-p span').show(t);
        $('.more-'+index+' p').show(t);
        $('.more-'+index+' .first-p span').show(t);
        $('.morecontent'+index).show(t);

      });
      $(".lesslink"+index).click(function(){
        $('.more-'+index+' .first').show(0);
        $('.more-'+index+' .last').hide(0);
        $(this).removeClass("less");
        $('.more-'+index+' p').hide(0);
        $('.morecontent'+index).hide(0);
        $('.more-'+index+'first-p').css('display','bock!important');
        $(".more-"+index+" .first-p:not('.morecontent')").show(0);
        $('.more-'+index+' .first-p span').hide(0);
        $('.morelink'+index).html(moretext);
        if($('.morelink'+index).is(':visible')){
        }else {
          $('.first-'+index+' p:nth-child(2)').show();
          $('.morecontent'+index).hide();
          if($('.morelink'+index).is(':visible')){
          }else {
            $('.first-'+index+' p:nth-child(3)').show();
            $('.morecontent'+index).hide();
          }
        }
        return false;
      });
    });
  }

  // Remove title class from content box
  $('.tab-content p').removeClass('product__bundle-title');

  //
  //
  // Default variant select
  //
  //
  var variantDefaultValue = $('.wb-product_native-variants span:first');

  $(".wb-fashion-variants").on('change', function() {
    if($(this).val()!=="") {
      $('.wb-product-addtocart-btn').css('cursor','pointer');
      $('.wb-product-addtocart-btn').removeClass('disabled');
      $('.wb-product-addtocart-btn').prop('disabled', false);
      $('.ajaxified-cart-feedback').hide();
      $('.wb-variant-select').css('border','none');
    }
  });

  $(".wb-fashion-variants").on('click', function(e){
    e.preventdefault;

    if ($(".wb-fashion-variants").hasClass('disabled')){
      //console.log('test');
    }
  });

  //
  //
  // Free shipping on Product Page
  //
  //

  var shippingText = $('.wb-header_shipping-text').first().text();
  $('#pp_shipping-text').html(shippingText);

  //
  //
  // QTY INPUT
  // Neues ProductPage Screendesign Aug2017
  //
  var $qtyInputGroup = $('.wb-qty-input');
  var $qtyDecButton = $qtyInputGroup.find('.btn-dec');
  var $qtyIncButton = $qtyInputGroup.find('.btn-inc');
  var $qtyInput = $qtyInputGroup.find('.qty-input');
  var maxqty = 50;
  $qtyIncButton.click(function(){
    var val = parseInt( $qtyInput.val() );
    $qtyInput.val( val + 1);
    if($qtyInput.val() >maxqty){
      $qtyInput.val( maxqty );
    }
  });

  $qtyDecButton.click(function(){
    var val = parseInt( $qtyInput.val() );
    if( val > 1){
      $qtyInput.val( val - 1);
    }
  });

  $qtyInput.on('change', function(e) {
    if( $qtyInput.val() > maxqty){
      $qtyInput.val( maxqty );
    }
  });


  var $variant_select = $('.wb-product-variants');

  $variant_select.selectpicker({
    style: 'wb-variant-select btn-lg',
    dropupAuto: false
  });
  $variant_select.selectpicker('refresh');
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|WomensBestApp/i.test(navigator.userAgent) ) {
    $variant_select.selectpicker('mobile');
  }

  $(".wb-product-variants > option").each(function() {
    var status = $(this).data('available');
    if(status == 'false'){
      var index =  $(this).index();
      $('.wb-product-variants .dropdown-menu').find("[data-original-index='" + index + "']").addClass('disabled');
    }
  });

  function setupVariantDropdowns() {
    var variantDropdowns = Array.prototype.slice.call(document.querySelectorAll('#add-to-cart-form select.wb-product-variants'));

    function updateVariantPriceInfo(selectedOption) {
      var priceInfo = document.querySelector('.wb-single-product_meta-container [data-price-info-target]');
      if (!priceInfo) {
        return;
      }
      var priceInfoLabel = priceInfo.dataset.priceInfoLabel;
      if (!priceInfoLabel) {
        return;
      }
      var size = selectedOption.dataset.servingSize;
      if (!size) {
        return;
      }
      var price = parseInt(selectedOption.dataset.priceCents);
      if (isNaN(price) || !price) {
        return;
      }

      var match = size.match(/^(\d+)\s?x/);
      if (!match || match.length < 2) {
        return;
      }
      var servingQuantity = parseInt(match[1] || 0);
      if (isNaN(servingQuantity) || servingQuantity < 1) {
        return;
      }
      var servingPrice = parseInt(price / servingQuantity);
      if (!Shopify.formatMoney) {
        return;
      }
      priceInfo.innerHTML = Shopify.formatMoney(servingPrice) + ' / ' + priceInfoLabel;
    }

    function updateVariantPrice(selectedOption) {
      var priceCompareTarget = $('.wb-single-product_meta-container [data-price-compare-target]');
      var priceOffTarget = $('.wb-single-product_meta-container [data-price-off-target]');
      var priceTarget = $('.wb-single-product_meta-container [data-price-target]');

      var priceCompare = selectedOption.dataset.priceCompare;
      var hasCompare = (priceCompare || '').length > 0;
      if (typeof priceCompare !== 'undefined') {
        priceCompareTarget.html(priceCompare);
      }
      priceCompareTarget.css('display', hasCompare ? '' : 'none');

      var priceOff = selectedOption.dataset.priceOff;
      if (priceOff !== 'undefined') {
        priceOffTarget.html(priceOff);
      }
      priceOffTarget.css('display', hasCompare ? '' : 'none');

      var price = selectedOption.dataset.price;
      if (typeof price !== 'undefined') {
        priceTarget.html(price);
      }
      if (hasCompare) {
        priceTarget.addClass('product-price__price--has-compare');
      } else {
        priceTarget.removeClass('product-price__price--has-compare');
      }

      updateVariantPriceInfo(selectedOption);

      if (typeof window.updatePPBestPoints !== 'undefined') {
        var priceCents = selectedOption.dataset.priceCents;
        if (typeof priceCents !== 'undefined') {
          window.updatePPBestPoints(priceCents);
        }
      }
    }




    function handleVariantChange(e) {
      var selectedOption = this.options[this.selectedIndex];
      if (!selectedOption) {
        return;
      }


      window.wbProductSlider.slideTo(0);
      window.changeVariantImages(selectedOption);
      window.changeVariantContents(selectedOption);
      window.changeVariantSize(selectedOption);
      window.changeVariantPrice(selectedOption);
      updateVariantPriceInfo(selectedOption);
      //updateVariantPrice(selectedOption);
      if (typeof e !== 'undefined') {
        window.handleVariantUrl(selectedOption);
      }
    }

    variantDropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('change', handleVariantChange, { passive: true });
      dropdown.addEventListener('change', function (event) {
        var $this = $(event.target.options[event.target.selectedIndex]);
        document.dispatchEvent(new CustomEvent('wb:variantchange', { detail: { nutrition: true, sku: $this.data('sku'), id: $this.data('flavor') } }));
      }, false);
      handleVariantChange.call(dropdown);
    });
  }

  setupVariantDropdowns();
  setupReadMore();

});


document.addEventListener('DOMContentLoaded', function () {


  function updateProductPrice(options) {
    const {
      variant_price,
      variant_compareprice,
      currentLang,
      currentShop ,
    } = options;
    
    function formatMoney(price) {
      return Shopify.formatMoney(price);
    }
    
    function getLanguageText() {
      const texts = {
        savingsText: {
          'de': `-{AMOUNT}%`,
          'fr': `-{AMOUNT}%`,
          'ar': `%{AMOUNT} خصم`,
          'en': `{AMOUNT}% OFF`
        },
        priceLabel: {
          'de': 'Preis:',
          'fr': 'Prix:',
          'ar': ':السعر',
          'en': 'Price:'
        }
      };
      return texts;
    }
    let texts = getLanguageText()
    // for return
    const priceContainer = document.querySelector('.product-price');
    if (!priceContainer) return;
    

    // savings
    const savingsElement = document.querySelector('.product-price__savings');
    if (savingsElement) {
      if (variant_compareprice > variant_price) {
        const savingsPercent = Math.round((variant_compareprice - variant_price) * 100.0 / variant_compareprice);
        const savingsText = texts.savingsText[currentLang] || texts.savingsText['en'];
        savingsElement.innerHTML = savingsText.replace('{AMOUNT}', `<span>${savingsPercent}</span>`);
        savingsElement.style.display = '';
      } else {
        savingsElement.style.display = 'none';
      }
    }

    // compare price
    const comparePriceElement = document.querySelector('.product-price__price-compare');
    if (comparePriceElement) {
      if (variant_compareprice > variant_price) {
        const formattedComparePrice = currentShop === 'me'
          ? `<span class="money">${formatMoney(variant_compareprice)}</span>`
          : formatMoney(variant_compareprice);

        comparePriceElement.innerHTML = formattedComparePrice;
        comparePriceElement.dataset.priceCompare = variant_compareprice;
        comparePriceElement.style.display = '';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }

    // current price
    const priceElement = document.querySelector('.product-price__price');
    if (priceElement) {
      const formattedPrice = currentShop === 'me'
        ? `<span class="money">${formatMoney(variant_price)}</span>`
        : formatMoney(variant_price);

      priceElement.innerHTML = formattedPrice;
      priceElement.dataset.price = variant_price;
      priceElement.classList.remove('product-price__price--has-compare');
      if (variant_compareprice > variant_price) {
        priceElement.classList.add('product-price__price--has-compare');
      } else {
        
      }
    }
    
  }
  


  function setupFashionView() {
    //Size SELECT
    var $input = $('#variant-id');
    var $addToCartBtn = $('.wb-product-addtocart-btn');
    var $sizeBtnsWrapper = $('.fashion-info-sticky ul.product-sizes');

    $('.wb-product-addtocart-btn:not(.wb-product-addtocart-btn-cts, .product-stl__submit-button)').on('click', function(event){
      if ($('.wb-product-addtocart-btn').hasClass('early-access-cta')) {
        //
      } else {
        if ($input.val() == ''){
          event.preventDefault();
          $('.product-sizes:not(.product-sizes-cts, .product-stl-sizes)').addClass('red');
          $('.choose-size-alert').show(100);
          $('.product-add-to-cart.is-sticky:not(.product-add-to-cart-cts)').addClass('product-add-to-cart-error');
        }
      }
    });

    $sizeBtnsWrapper.each(function(){
      var $sizeBtns = $(this).find('li');

      $sizeBtns.each(function(i) {
        var $this = $(this);
        $this.on('click', function(e) {
       
          var $this = $(this);
          var variant_id = $(this).data('size');
          var variant_sku = $(this).data('sku');
          var variant_price = $(this).data('price');
          var variant_compareprice = $(this).data('compareprice');
       
          if (! $this.hasClass('disabled')) {
            //Classes
            $sizeBtns.removeClass('active');
            $this.addClass('active');

            $('.product-sizes').removeClass('red');

            $('.choose-size-alert').hide(100);
            $('.product-add-to-cart.is-sticky').removeClass('product-add-to-cart-error');

            if($(this).data('set')){
              return;
            }

            if (variant_id) {
              $addToCartBtn.attr("disabled", false);
              if($input.hasClass('fashion-set')){}else{
                $input.val(variant_id);
                $input.attr('data-sku',variant_sku);
              }
              // $('#wb-fashion .fashion-info-flex #in-den-warenkorb').css('background','#ffb00d');
              $('#wb-fashion .fashion-info-flex #in-den-warenkorb').removeClass('select');

              document.dispatchEvent(new CustomEvent('wb:variantchange', { detail: { sportswear: true, sku: $this.data('sku'), id: $this.data('size'), name: $this.data('title') } }));
              //console.log("variant_price 0 ",variant_price)
              if(variant_price && variant_compareprice){
             //   console.log("variant_price 1 ",variant_price)
                updateProductPrice({
                  variant_price: variant_price,
                  variant_compareprice: variant_compareprice,
                  currentLang: document.documentElement.lang.split(/-/)[0],
                  currentShop: currentShop,
                });
                
              }
            } else {
              $addToCartBtn.attr("disabled", true);

            }
          }
        });
      });
    });

    $('.is-sticky #in-den-warenkorb.select').on('click', function(){
      if (!$(this).hasClass('select')) {
        return;
      }
      if(isMobile()){
        $([document.documentElement, document.body]).animate({
          scrollTop: $(".fashion-info-flex").offset().top-100
        }, 500);
      }
    });
  }

  function setupFashionSet(){
    var $fashionSetData = $('.product-fashion--set-data');
    var $addToCartBtn = $('.wb-product-addtocart-btn');

    function addFashionPropData(data,input){
      input.attr('value',data);
    }


    $addToCartBtn.addClass('select');

    $fashionSetData.each(function(index){
      var $setSwiper = $(this).find('.swiper-slide'),
          $that = $(this),
          thatIndex = index,
          $setInput = $(this).find('input'),
          enableAddtoCart = false,
          enableAddtoCartClassCheck = false;


      $setSwiper.click(function(index){
        var $setData = $(this).data('info'),
            $variantData = $setData.split(';'),
            $setSizesWrapper = $that.find('.product-sizes'),
            $setSizes = $that.find('.product-sizes li'),
            $setProductSizes = $('.product-variants--set .product-sizes'),
            $picWrapperIndex = $('.wb-picture-wrapper--'+thatIndex),
            $picWrapperIndexImage0 = $($($picWrapperIndex[0]).find('img')[0]),
            $picWrapperIndexImage1 = $($($picWrapperIndex[1]).find('img')[0]);

        $setSizes.each(function(index){
          var itemIndex = index+1;
          //console.log($setSizes.length,$variantData.length)


          console.log($variantData);

          if($setSizes.length>$variantData.length && itemIndex == $setSizes.length){
            if($(this).hasClass('active') && !$(this).hasClass('disabled')){
              $(this).parent().removeClass('selected');
              addFashionPropData('',$setInput);
              $addToCartBtn.addClass('select');
            }
            $(this).remove();

          }else if($setSizes.length < $variantData.length && itemIndex == $setSizes.length){
            $setSizesWrapper.append('<li data-set="'+$variantData[itemIndex]+'" data-instock="'+$variantData[itemIndex].split(',')[5]+'" data-title="'+$variantData[itemIndex].split(',')[2]+'"><span>'+$variantData[itemIndex].split(',')[2]+'</span></li>');
            setupFashionView();
          }

          if($variantData[index] != undefined){

            $(this).attr('data-set',$variantData[index]);
            $(this).attr('data-instock',$variantData[index].split(',')[5]);

            if(window.screen.availWidth > 991){
                if(thatIndex == 1){
                $picWrapperIndexImage0.attr('data-src',$variantData[index].split(',')[7]).attr('src',$variantData[index].split(',')[7]);
                $picWrapperIndexImage1.attr('data-src',$variantData[index].split(',')[6]).attr('src',$variantData[index].split(',')[6]);
                }else{
                $picWrapperIndexImage0.attr('data-src',$variantData[index].split(',')[6]).attr('src',$variantData[index].split(',')[6]);
                $picWrapperIndexImage1.attr('data-src',$variantData[index].split(',')[7]).attr('src',$variantData[index].split(',')[7]);
                }
            }

            //$(this).find('.notifyMe').remove();
            $(this).find('svg').remove();
            if(!JSON.parse($variantData[index].split(',')[5].toLowerCase())){

              if($(this).hasClass('active')){
                $(this).parent().removeClass('selected');
                $addToCartBtn.addClass('select');
                $(this).removeClass('active');
              }
              $(this).addClass('disabled');
              $(this).append('<svg class="product-notify__icon"><use xlink:href="#svg-product-sold-out-notify"/></svg><svg class="product__icon-strike-through"><use xlink:href="#svg-product-sold-out-strike-through"/></svg>')
            }else {
              $(this).removeClass('disabled');
            }

            //$(this).attr('data-size',$variantData[index].split(',')[3]);
          }else {
            console.log('not found')
          }


        });

function renderSlide(img){
  return`<div class="swiper-slide">
           <div class="wb-picture-wrapper" data-index="0">
            <canvas class="wb-picture__canvas" width="1440" height="1800"></canvas>
             <picture>
               <img class="wb-picture__img wb-product__zoom " src="${img}" alt="Power Best-Seller Set" data-zoom-src="${img}" data-zoom-width="1440" data-zoom-height="1800">
              </picture>
            </div>
          </div>`;
                      }


        var activeFashionSetSwiper = $('.fashion-color-switch .swiper-slide-active');
         if(window.screen.availWidth <= 991 && activeFashionSetSwiper.length > 1){
            document.querySelector('#product_image_slider_mobile').swiper.removeAllSlides();
            document.querySelector('#product_image_slider_mobile').swiper.addSlide(1, [renderSlide($(activeFashionSetSwiper[0]).attr('data-info').split(';')[0].split(',')[6]),
                                                                                       renderSlide($(activeFashionSetSwiper[0]).attr('data-info').split(';')[0].split(',')[7]),
                                                                                       renderSlide($(activeFashionSetSwiper[0]).attr('data-info').split(';')[0].split(',')[8]),
                                                                                       renderSlide($(activeFashionSetSwiper[1]).attr('data-info').split(';')[0].split(',')[6]),
                                                                                       renderSlide($(activeFashionSetSwiper[1]).attr('data-info').split(';')[0].split(',')[7]),
                                                                                       renderSlide($(activeFashionSetSwiper[1]).attr('data-info').split(';')[0].split(',')[8])]);
            }

          if($setProductSizes.length < 3 && thatIndex == 0){
              $picWrapperIndex = $('.wb-picture-wrapper--2')
              $picWrapperIndexImage0 = $($($picWrapperIndex[0]).find('img')[0]);

            $picWrapperIndexImage0.attr('data-src',$variantData[0].split(',')[8]).attr('src',$variantData[0].split(',')[8]);

            }

          if($setProductSizes.length < 3 && thatIndex == 1){
              $picWrapperIndex = $('.wb-picture-wrapper--2')
              $picWrapperIndexImage1 = $($($picWrapperIndex[1]).find('img')[0]);


            $picWrapperIndexImage1.attr('data-src',$variantData[1].split(',')[8]).attr('src',$variantData[1].split(',')[8]);

            }




        var $setSizesActive = $that.find('.product-sizes li.active');
        if($setSizesActive.length > 0){
          addFashionPropData($setSizesActive.attr('data-set'),$setInput);
        }



      });


      $(this).find('.product-sizes li').click(function(){
        var fashionSetDataArray = [],
            fashionSetDataArrayClassCheck = [],
            $fashionSetDataInput = $that.find('.fashion_set--variant-input');


        $(this).parent().addClass('selected');
        addFashionPropData($(this).attr('data-set'),$setInput);

        $fashionSetDataInput.each(function(){
          fashionSetDataArray.push($(this).attr('value'));
        });

        $('.product-fashion--set-data .product-sizes').each(function(){
          fashionSetDataArrayClassCheck.push($(this));
        });


        enableAddtoCart = fashionSetDataArray.every(function(e){
          return e !== '';
        });

        enableAddtoCartClassCheck = fashionSetDataArrayClassCheck.every(function(e){
          return e.hasClass('selected');
        });

        //console.log(enableAddtoCartClassCheck)

        if(enableAddtoCart && enableAddtoCartClassCheck){
          $addToCartBtn.removeClass('select');
          //$addToCartBtn.attr("disabled", false);
        }


      });

      $addToCartBtn.click(function(e){

        if($(this).hasClass('select')){

          e.preventDefault();

          $('.product-sizes').each(function(){
            if(!$(this).hasClass("selected")){
              $(this).addClass('red');
            }
          })



          $('.choose-size-alert').show(100);
          $('.product-add-to-cart.is-sticky').addClass('product-add-to-cart-error');

        }

        //console.log('disable click')

      });
    });

$('#fashion-color-switch .swiper-slide').first().trigger('click');
$('#fashion-color-switch1 .swiper-slide').first().trigger('click');
$('#fashion-color-switch2 .swiper-slide').first().trigger('click');

    function setupModelSize() {
      if($('.wb-single-product').hasClass('wb-fashion-set')){
      $('.wb-fashion-color-switch .swiper-slide-active').each(function(index){
      var activeData = $(this).attr('data-info').split(',')[1];
      var modelSize = window.wbFashionsetModelInfo.sizes[activeData];
      $($('.wb-fashion--model-size')[index]).html(modelSize);
      $($('.wb-fashion--model-size-tab')[index]).html(modelSize);
    });
     }
    }setupModelSize();

    $('#fashion-color-switch .swiper-slide').click(function(){
    setupModelSize();
    })
  }


  function setupFitnessView() {
    //Flavor SELECT
    var $input = $('#flavor-id');
    var $addToCartBtn = $('.wb-product-addtocart-btn');
    var $flavorBtns = $('.fitness-info-sticky ul.product-flavors li');
    var variantTitle = $('.product-flavors-title__variant').first();
    var $productPrice = $('.product-price__price');
    var $productPriceCompare = $('.product-price__price-compare');
    var $productPriceSavings = $('.product-price__savings span');


    $flavorBtns.each(function(i) {
      var $this = $(this);

      $this.on('click', function(e) {
        var $this = $(this);
        var variant_id = $(this).data('flavor');
        var variant_sku = $(this).data('sku');
        var variant_price = $(this).data('price');
        var variant_price_cents = $(this).data('price-cents');
        var variant_compprice = $(this).data('price-compare');
        var variant_compprice_cents = parseInt((($(this).data('price-compare') || '').match(/\d+/g) || []).join('')) || '';


        if(variant_price != $productPrice.text() && $productPrice.length > 0 ){  // update price
          $productPrice.html(variant_price);
          $productPrice.attr('data-price',variant_price_cents);
          if($productPriceCompare.length > 0 && $productPriceSavings.length > 0){
            $productPriceCompare.html(variant_compprice);
            $productPriceCompare.attr('data-price-compare',variant_compprice_cents);
            if (variant_compprice_cents) {
              var variant_savings = Math.round((1-(variant_price_cents / variant_compprice_cents))*100);
              $productPriceSavings.html(variant_savings);
              $productPrice.addClass('product-price__price--has-compare');
              $('.product-price__savings').show();
            } else {
              $productPrice.removeClass('product-price__price--has-compare');
              $('.product-price__savings').hide();
              $productPriceSavings.html('');
            }
          }
          //$('.wb-smile-pp-value').html(variant_price_cents)

          if (typeof window.updatePPBestPoints !== 'undefined') {
            window.updatePPBestPoints(variant_price_cents);
          }
        }

        if (! $this.hasClass('disabled')) {
          //$('.choose-flavor-alert').hide(100);
          if (variant_id) {
            $addToCartBtn.attr("disabled", false);
            $input.val(variant_id);
            $input.attr('data-sku',variant_sku);
            // $('.fitness-info-flex #in-den-warenkorb').css('background','#ffb00d');
            // $('.fitness-info-flex #in-den-warenkorb').removeClass('select');

            document.dispatchEvent(new CustomEvent('wb:variantchange', { detail: { nutrition: true, sku: $this.data('sku'), id: $this.data('flavor') } }));
          } else {
            $addToCartBtn.attr("disabled", true);
          }
        }
      });
    });
    // update price mobile
    $input.change(function(){
      var variant_price = $(this).find(':selected').attr('data-price')
      var variant_price_cents = $(this).find(':selected').attr('data-price-cents');
      var variant_compprice = $(this).find(':selected').attr('data-price-compare');
      var variant_compprice_cents = parseInt((($(this).find(':selected').attr('data-price-compare') || '').match(/\d+/g) || []).join(''));

      if($(this).find(':selected').attr('data-price') != $productPrice.text() && $productPrice.length > 0 ){
        $productPrice.html(variant_price);
        $productPrice.attr('data-price',variant_price_cents);
        if($productPriceCompare.length > 0 && $productPriceSavings.length > 0){
          $productPriceCompare.html(variant_compprice);
          $productPriceCompare.attr('data-price-compare',variant_compprice_cents);
          if (variant_compprice_cents) {
            var variant_savings = Math.round((1-(variant_price_cents / variant_compprice_cents))*100);
            $productPriceSavings.html(variant_savings);
            $productPrice.addClass('product-price__price--has-compare');
            $('.product-price__savings').show();
          } else {
            $productPrice.removeClass('product-price__price--has-compare');
            $('.product-price__savings').hide();
            $productPriceSavings.html('');
          }
        }

        if (typeof window.updatePPBestPoints !== 'undefined') {
          window.updatePPBestPoints(variant_price_cents);
        }

      }
    });


     function selectFlavorViaName() {

      function findGetParameter(parameterName) {
        var result = null,
          tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        console.log('f result', result);
        return result;
      }

      var selectedName = findGetParameter('flavourName');

      if (document.querySelector('.fitness-info-flex') !== null && typeof selectedName !== undefined && selectedName && selectedName.length > 0) {
        var option = document.querySelector('#add-to-cart-form #flavor-id option[data-variant-name="' + selectedName + '"]');
        if (!option) {
          return;
        }
        if (option.hasAttribute('disabled')) {
          return;
        }
        var variantId = $(option).val();
        if (!variantId) {
          return;
        }
        setTimeout(function () {
          $(document.querySelector('#add-to-cart-form .product-flavors li[data-variant-name="' + selectedName + '"]')).trigger('click');
        }, 1000);
        $(document.querySelector('#add-to-cart-form select[name*="id"]')).val(variantId).selectpicker('refresh');
      }
    }

    function selectFlavorViaSkuParameter() {
      function findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        return result;
      }

      var selectedSku = findGetParameter('sku');

      if (document.querySelector('.fitness-info-flex') !== null && typeof selectedSku !== undefined && selectedSku && selectedSku.length > 0) {
        var option = document.querySelector('#add-to-cart-form #flavor-id option[data-sku="' + selectedSku + '"]');
        if (!option) {
          return;
        }
        if (option.hasAttribute('disabled')) {
          return;
        }
        var variantId = $(option).val();
        if (!variantId) {
          return;
        }
        setTimeout(function () {
          $(document.querySelector('#add-to-cart-form .product-flavors li[data-sku="' + selectedSku + '"]')).trigger('click');
        }, 1000);
        $(document.querySelector('#add-to-cart-form select[name*="id"]')).val(variantId).selectpicker('refresh');
      }
    }

    function setupProductLaunchVideoModal() {
      var modals = Array.prototype.slice.call(document.querySelectorAll('.product-launch-info__video-modal'));
      modals.forEach(function (modal) {
        var $modal = $(modal);
        var video = modal.querySelector('video');
        $modal.on('hide.bs.modal', function () {
          if (video) {
            try {
              video.pause();
            } catch (e) {
              //
            }
          }
        });
      });
      var isBundle = document.getElementById('product-sections') != null;
      if (!isBundle) {
        return;
      }
      var main = document.querySelector('main');
      if (!main) {
        return;
      }
      modals.forEach(function (modal) {
        main.appendChild(modal);
      });
    }

    selectFlavorViaName();
    selectFlavorViaSkuParameter();
    setupProductLaunchVideoModal();
  }

  setupFashionView();
  setupFitnessView();
  setupFashionSet();

}, { passive: true });

document.addEventListener('DOMContentLoaded', function () {
  var $$ = window.Swiper.$;

  function setupTabs() {
    var desktopTabs = Array.prototype.slice.call(document.querySelectorAll('.desktop-tab'));
    desktopTabs.forEach(function(desktopTab) {
      var tabHeadlines = Array.prototype.slice.call(desktopTab.querySelectorAll('.desktop-tab-headline[data-tab]'));
      tabHeadlines.forEach(function(tabHeadline) {
        tabHeadline.addEventListener('click', function (event) {
          var tabId = tabHeadline.getAttribute('data-tab');
          var tabContent = tabHeadline.nextElementSibling.classList.contains('desktop-tab-content') && tabHeadline.nextElementSibling.getAttribute('data-tab-content') === tabId ? tabHeadline.nextElementSibling : desktopTab.querySelector('.desktop-tab-content[data-tab-content="' + tabId + '"]');
          if (!tabContent) {
            return;
          }
          event.preventDefault();
          $(tabContent).slideToggle(225);
          tabHeadline.classList.toggle('active');
        });
      });
    });
  }

  function setupPreviews() {
    var elTarget = document.querySelector('.wb-single-product_product-image-container picture');
    if (!elTarget) {
      return;
    }
    var elPreviews = Array.prototype.slice.call(document.querySelectorAll('.wb-single-product_product-image-previews-container img'));
    if (elPreviews.length < 1) {
      return;
    }

    function getWrapper(elPreview) {
      return elPreview.closest('.wb-picture-wrapper[data-index]');
    }

    function getOptions(elWrapper) {
      if (!elWrapper) {
        return;
      }
      switch (elWrapper.dataset.index) {
        case '0':
          return { crop: 'bottom' };
        case '2':
          return { crop: 'top' };
        default:
          return { crop: 'top' };
      }
    }

    function hideWrapper(elWrapper) {
      if (!elWrapper) {
        return;
      }
      elWrapper.style.display = 'none'
    }

    function showWrapper(elWrapper) {
      if (!elWrapper) {
        return;
      }
      elWrapper.style.display = '';
    }

    function showWrappers(except) {
      elPreviews.forEach(function (elPreview) {
        var elWrapper = getWrapper(elPreview);
        if (except === elWrapper) {
          return;
        }
        showWrapper(elWrapper);
      });
    }

    elPreviews.forEach(function (elPreview) {
      var elWrapper = getWrapper(elPreview);
      var options = getOptions(elWrapper);
      elPreview.addEventListener('click', function () {
        window.wbPicture.replaceSrc(elTarget, elPreview.getAttribute('src') || elPreview.getAttribute('data-src'), options);
        hideWrapper(elWrapper);
        showWrappers(elWrapper);
      }, { passive: true });
    });
  }

  function setupMagnify() {
    var elImgZoom = $$('#img-zoom');
    if (elImgZoom.length !== 1) {
      return;
    }

    function onMouseLeave(elImgZoom, event) {
      elImgZoom.transition(0).transform('translate3d(0,0,0) scale(1)').css({ opacity: 0});
    }
    function onMouseMove(elMagnify, elImgZoom, event) {
      var x = Math.min(Math.max((event.offsetX / elMagnify.outerWidth()) * 100, 0), 100);
      var y = Math.min(Math.max((event.offsetY / elMagnify.outerHeight()) * 100, 0), 100);
      elImgZoom.transition(0).css('transformOrigin', x + '% ' + y + '%');
    }
    function onMouseEnter(elMagnify, elImgZoom, event) {
      var src = elMagnify.attr('data-magnify-src') || '';
      elImgZoom.transition(0).css({ backgroundImage: 'url(' + src + ')' }).transform('translate3d(0,0,0) scale(2)').css({ opacity: 1 });
    }

    $$('img[data-magnify-src]').each(function (elIndex, elMagnify) {
      elMagnify = $$(elMagnify);
      elMagnify.on('mouseenter', onMouseEnter.bind(undefined, elMagnify, elImgZoom), false);
      elMagnify.on('mousemove', onMouseMove.bind(undefined, elMagnify, elImgZoom), false);
      elMagnify.on('mouseleave', onMouseLeave.bind(undefined, elImgZoom), false);
    });
  }

  function setupProductInfoBannerSlider() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('.product-info-banner .swiper-container:not(.swiper-container-initialized)'));
    elements.forEach(function (element) {
      var id = uuidv4();
      element.id = 'product-slider-' + id;
      var swiper = new Swiper(element, {
        navigation: false,
        scrollbar: false,
        navigation: {
          nextEl: '#' + element.id + ' .wb-product-image-slider__nav-next',
          prevEl: '#' + element.id + ' .wb-product-image-slider__nav-prev',
          disabledClass: 'wb-product-image-slider__nav--disabled',
          hiddenClass: 'wb-product-image-slider__nav--disabled'
        },
        scrollbar: {
          el: '.wb-product-image-slider__scrollbar',
          // dragClass: 'wb-product-image-slider__scrollbar-drag',
          enabled: true,
          draggable: false,
          dragSize: 60,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        roundLengths: true,
        // loop: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          invert: true
        },
        lazyLoad: {
          enabled: true,
          loadPrevNext: true
        },
      });
    });
  }

  setupPreviews();
  setupMagnify();
  setupProductInfoBannerSlider();
}, { passive: true });

window.initCabSlider = function () {
  initProductSlider('#cab_slider');
  initProductSlider('#cab_slider_new');
}

/* aminoProfile script beginn */

document.addEventListener("DOMContentLoaded", () => {

  const profile = document.querySelector('.amino-profile');
  if (!profile) {
    return;
  }

const aminoProfileElements = document.getElementsByClassName("product-aacp__aminoProfile");
const arrowDownElement = document.getElementById("product-aacp__arrowDownID");
const elementsOfProgressBar = document.getElementsByClassName("product-aacp__progress-bar");
const arrowTextID = document.getElementById("product-aacp__arrowDownTextID");
const valuesArray = document.getElementsByClassName("product-aacp__progress-value");
const arrowDownContainer = document.getElementById("product-aacp__arrow-down__element_one");
const arrowDownTextContainer = document.getElementById("product-aacp__arrow-down__element_two");
const servingsBlock = document.getElementsByClassName("product-aacp__servings");
const servingsItemContainer = document.getElementById("product-aacp__servings-item-container");

  if (!servingsItemContainer) {
    return;
  }

var settingFlag = 0;


function isOdd(num) {
    if ((num % 2) == 0) {
        return false;
    }
    return true;
}

var max_height = servingsItemContainer.scrollHeight;



function checkWidth() {
  if (max_height > 650) {
      if (arrowDownElement != null) {
        arrowDownElement.addEventListener("click", showAminoProfile);
      }
      if (arrowTextID != null) {
        arrowTextID.addEventListener("click", showAminoProfile);
      }
    return;
  }
  if (max_height <= 650) {
    arrowDownContainer.style.display = "none";
    arrowDownTextContainer.style.display = "none";
    servingsItemContainer.classList.remove("amino-profile");
    return;
  }
}

checkWidth();


function showAminoProfile() {
    settingFlag += 1;
    if (isOdd(settingFlag)) {
        animateAminoProfile();
        return;
    }
    hideAminoProfile();
}

  function animateAminoProfile() {
    let id = null;
    let pos = 400;
    let len = elementsOfProgressBar.length;
    let elementHeight = 75;
    let deg = 45;
    clearInterval(id);
    id = setInterval(showAnimate, 1);
    function showAnimate() {
        if ((pos >= max_height) && deg >= 225) {
            clearInterval(id);
            arrowDownElement.style.transform = "rotate(225deg)";
            if (arrowTextID.innerHTML == "Mehr anzeigen") {
                arrowTextID.innerHTML = "Weniger anzeigen";
            }
            if (arrowTextID.innerHTML == "View More") {
                arrowTextID.innerHTML = "View Less";
            }
            if (arrowTextID.innerHTML == "En savoir plus") {
                arrowTextID.innerHTML = "Voir moins";
            }

            return;
        }
        else {
            pos += 30;
            deg += 6;
            servingsItemContainer.style.maxHeight = pos + "px";
            arrowDownElement.style.transform = "rotate(" + deg + "deg)";
        }
    }
  }

function hideAminoProfile() {
    let id = null;
    let pos = max_height;
    let deg = 225;
    clearInterval(id);
    id = setInterval(hideAnimate, 1);
    function hideAnimate() {
        if (pos <= 400 && deg <= 45) {
            if (arrowTextID.innerHTML == "Weniger anzeigen") {
                arrowTextID.innerHTML = "Mehr anzeigen";
            }
            if (arrowTextID.innerHTML == "View Less") {
                arrowTextID.innerHTML = "View More";
            }
            if (arrowTextID.innerHTML == "Voir moins") {
                arrowTextID.innerHTML = "En savoir plus";
            }
            clearInterval(id);
            servingsItemContainer.style.maxHeight = "400px";
            arrowDownElement.style.transform = "rotate(45deg)";
            return;
        }
        else {
            pos -= 30;
            deg -= 6;
          servingsItemContainer.style.maxHeight = pos + "px";
            arrowDownElement.style.transform = "rotate(" + deg + "deg)";
        }
    }
}

});

/* aminoProfile script end */

